import { roundToDecimals } from "../../../helpers/FormatHelper";
import { voidBNAdjustment } from "../../../networking/NetworkingBNAdjustment";

 export const calculateBuyAmount = (rateTerms, rate, amount, buyScale ) => {
  let buyAmount = 0;
  if(rate > 0)
  {
    if (rateTerms === 'I') {
        buyAmount = amount / rate;
     
    } else {
        buyAmount= amount * rate;      
    }
  }
    return  roundToDecimals(buyAmount, buyScale);
  
  };

    export const calculateTotalAmounts = (adjustmentRows) =>{
    let buyAmount = 0;

    if(adjustmentRows)
    {
        adjustmentRows.forEach((d)=>{
            buyAmount += d.BuyAmount;
        })
    }
    return {BuyAmount: buyAmount};
} 

export const voidAdjustment = async(adjustmentID) =>{
  const responseOrder = await voidBNAdjustment(adjustmentID);

  if(responseOrder.httpStatusCode !== 200)
  {
    return {Title: 'Error', Message: responseOrder.Message, Success: false, OrderNo:0}
  }
  else{
    return {Title: 'Success', Message: 'Order was void successfully', Success: true}
  }
}
